import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Pagination,
  Tooltip,
  OverlayTrigger,
  Col,
} from "react-bootstrap";

const BannerNoticeFilter = (props) => {
  const { handleNavigateToAddBannerNotice } = props;
  useEffect(() => {}, []);

  return (
    <>
      <Col md={12} style={{ textAlign: "right", marginBottom: "30px" }}>
        <Button
          variant="primary"
          style={{
            marginTop: "2px",
            backgroundColor: "black",
            color: "white",
          }}
          onClick={() => {
            handleNavigateToAddBannerNotice();
          }}
        >
          <i class="fa fa-plus" aria-hidden="true"></i> Add Banner Notice
        </Button>
      </Col>
    </>
  );
};
export default BannerNoticeFilter;
